import * as TYPES from './types';

const initialState = {
  list: [],
  unusedList: [],
  fetching: false,
  errorCreated: false,
  isCreated: false,
  isEdited: false,
  errorMessages: false,
  total: 0,
  fetchedNewDevices: null,
};
const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TYPES.GET_HOOD_DEVICES_REQUEST:
    case TYPES.DELETE_HOOD_DEVICES_REQUEST:
    case TYPES.CREATE_HOOD_DEVICE_REQUEST:
    case TYPES.UPDATE_HOOD_DEVICE_REQUEST:
    case TYPES.GET_UNUSED_HOOD_DEVICES_REQUEST:
    case TYPES.FETCH_HOOD_DEVICES_REQUEST:
      return {
        ...state,
        fetching: true,
        isCreated: false,
        errorCreated: false,
        fetchedNewDevices: null,
      };

    case TYPES.GET_HOOD_DEVICES_ERROR:
    case TYPES.DELETE_HOOD_DEVICES_ERROR:
    case TYPES.UPDATE_HOOD_DEVICE_ERROR:
    case TYPES.GET_UNUSED_HOOD_DEVICES_ERROR:
    case TYPES.FETCH_HOOD_DEVICES_ERROR:
      return {
        ...state,
        errorMessages: payload,
        fetching: false,
        fetchedNewDevices: null,
      };

    case TYPES.CREATE_HOOD_DEVICE_ERROR: {
      return {
        ...state,
        errorCreated: payload,
        fetching: false,
      };
    }

    case TYPES.DELETE_HOOD_DEVICES_SUCCESS: {
      const list = state.list;
      const index = list.findIndex((item) => item.id === payload.id);
      if (index !== -1) list.splice(index, 1);
      else list.push(index);
      return {
        ...state,
        list,
        fetching: false,
        total: state.total - 1,
      };
    }

    case TYPES.CREATE_HOOD_DEVICE_SUCCESS: {
      return {
        ...state,
        list: [...state.list, payload],
        fetching: false,
        total: state.total + 1,
        isCreated: true,
      };
    }

    case TYPES.UPDATE_HOOD_DEVICE_SUCCESS: {
      const list = state.list;
      const index = list.findIndex((item) => item.id === payload.id);
      if (index !== -1) list.splice(index, 1, payload);
      else list.push(payload);
      return {
        ...state,
        list,
        fetching: false,
        isEdited: true,
      };
    }

    case TYPES.GET_HOOD_DEVICES_SUCCESS: {
      return {
        ...state,
        total: payload.total,
        list: [...state.list, ...payload.devices],
        fetching: false,
      };
    }

    case TYPES.FETCH_HOOD_DEVICES_SUCCESS: {
      return {
        ...state,
        total: payload.total,
        list: [...state.list, ...payload.devices],
        fetching: false,
        fetchedNewDevices: payload.total - state.total,
      };
    }

    case TYPES.GET_UNUSED_HOOD_DEVICES_SUCCESS: {
      return {
        ...state,
        total: payload.total,
        unusedList: [...payload.devices],
        fetching: false,
      };
    }

    case 'CLEAR_ERRORS': {
      return {
        ...state,
        errorCreated: false,
        errorMessages: false,
      };
    }

    case TYPES.CLEAR_CREATED_HOOD_DEVICE: {
      return { ...state, isCreated: false };
    }

    case TYPES.CLEAR_EDITED_HOOD_DEVICE: {
      return { ...state, isEdited: false };
    }

    case 'EMPTY_HOODEDCONTROLDEVICES_LIST': {
      return { ...state, list: [] };
    }

    default:
      return { ...state };
  }
};

export default reducer;
